import React, { useEffect, useRef, useState } from 'react';
import './OurTraining.css';

const features = [
  { icon: '📘', label: 'Industry-oriented syllabus' },
  { icon: '💻', label: 'Practical coding projects and case studies' },
  { icon: '📝', label: 'Mock exams and interview preparation' },
  { icon: '🚀', label: 'Placement assistance and career guidance' },
  { icon: '🕐', label: 'Flexible online & offline batches' },
  { icon: '🎓', label: 'Expert mentors with real-world experience' },
];

const OurTraining = () => {
  const [visible, setVisible] = useState([]);
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = itemRefs.current.map((ref, i) => {
      if (!ref) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisible(prev => [...new Set([...prev, i])]);
            obs.disconnect();
          }
        },
        { threshold: 0.2 }
      );
      obs.observe(ref);
      return obs;
    });
    return () => observers.forEach(o => o && o.disconnect());
  }, []);

  return (
    <div className="trainer_alpha_pg_fluid">
      {/* Ambient orbs */}
      <div className="trainer_alpha_pg_orb trainer_alpha_pg_orb--1" />
      <div className="trainer_alpha_pg_orb trainer_alpha_pg_orb--2" />
      <div className="trainer_alpha_pg_orb trainer_alpha_pg_orb--3" />

      {/* Noise grain overlay */}
      <div className="trainer_alpha_pg_grain" />

      <div className="trainer_alpha_pg_container">
        {/* Header */}
        <div className="trainer_alpha_pg_header">
          <span className="trainer_alpha_pg_eyebrow">What We Offer</span>
          <h1 className="trainer_alpha_pg_heading">
            Our <span className="trainer_alpha_pg_heading--accent">Training</span>
          </h1>
          <div className="trainer_alpha_pg_divider">
            <span className="trainer_alpha_pg_divider--line" />
            <span className="trainer_alpha_pg_divider--diamond" />
            <span className="trainer_alpha_pg_divider--line" />
          </div>
          <p className="trainer_alpha_pg_subtext">
            Crafted for real-world success — every module designed to launch your career forward.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="trainer_alpha_pg_grid">
          {features.map((feat, i) => (
            <div
              key={i}
              ref={el => (itemRefs.current[i] = el)}
              className={`trainer_alpha_pg_card ${visible.includes(i) ? 'trainer_alpha_pg_card--visible' : ''}`}
              style={{ '--delay': `${i * 0.12}s` }}
            >
              <div className="trainer_alpha_pg_card__glow" />
              <div className="trainer_alpha_pg_card__icon">{feat.icon}</div>
              <p className="trainer_alpha_pg_card__label">{feat.label}</p>
              <div className="trainer_alpha_pg_card__bar" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurTraining;